import Vue from 'vue';
import { Commit } from 'vuex';
import { Controller } from '@/interfaces/controllers';

interface ControllerState {
	controllers: {
		[id: number]: Controller;
	};
}

export default {
	namespaced: true,
	state: {
		controllers: [],
	} as ControllerState,
	getters: {
		getControllers: (state: ControllerState): Controller[] => {
			return Object.values(state.controllers);
		},

		getController:
			(state: ControllerState) =>
			(id: number): Controller | undefined => {
				return state.controllers[id];
			},

		getControllerByGUID:
			(state: ControllerState) =>
			(guid: string): Controller | undefined => {
				return Object.values(state.controllers).find((controller) => controller.guid === guid);
			},
	},
	mutations: {
		SET_CONTROLLERS(state: ControllerState, controllers: Controller[]): void {
			const ret: { [id: number]: Controller } = {};
			state.controllers = controllers.reduce((obj, controllers) => {
				obj[controllers.id] = controllers;
				return obj;
			}, ret);
		},

		ADD_CONTROLLERS(state: ControllerState, controllers: Controller[]): void {
			controllers.forEach((controller) => Vue.set(state.controllers, controller.id, controller));
		},

		CLEAN_CONTROLLERS(state: ControllerState): void {
			state.controllers = {};
		},

		REMOVE_CONTROLLER(state: ControllerState, controllerId: number): void {
			Vue.delete(state.controllers, controllerId);
		},
	},
	actions: {
		async fetchControllers({ commit }: { commit: Commit }): Promise<void> {
			const response = await Vue.axios.get(`${process.env.VUE_APP_API_URL}/controllers`);

			if (response && response.status === 200) {
				commit('SET_CONTROLLERS', response.data.data);
			}
		},

		async deleteController({ commit }: { commit: Commit }, { id }: { id: number }): Promise<void> {
			const response = await Vue.axios.delete(`${process.env.VUE_APP_API_URL}/controllers/${id}`);
			if (response && response.status === 200) {
				commit('REMOVE_CONTROLLER', id);
			}
		},

		cleanControllers({ commit }: { commit: Commit }): void {
			commit('CLEAN_CONTROLLERS');
		},
	},
};
